import preventLinkRedirection from '../utils/helpers/prevent-link-redirection';
import proxyClickToParentContext from '../utils/helpers/proxy-click-to-parent-context';
import blurFocusedElementOnImageClick from '../utils/helpers/blur-focused-element-on-image-click';

const documentClickHandler = (e) => {
  preventLinkRedirection(e);
  proxyClickToParentContext(e);
  blurFocusedElementOnImageClick(e);
};

export default documentClickHandler;
